<!-- Rebate Request - Measurement Committee / Economic Committee - Release Rebate -->
<div *ngIf="!isRequestSucceeded">
    <!-- Form Title -->
    <h2 class="sectionTitle">Restudy / Cancel Rebate</h2><!--Phase1 Galal Task19-->
    <div *ngIf="formMode == 2" class="bs-callout bs-callout-info">
        <p>This Rebate Request has been released</p>
    </div>
    <!-- Rebate Request - Display Mode -->
    <app-rebate-request #rebateRequest (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)"></app-rebate-request>
    <!-- Accurate Data Form -->
    <div *ngIf="isAccurateDataForm" class="form-container">
        <fieldset [disabled]="true">
            <div class="form-section">
                <h4 class="section-title">Accurate Data Form</h4>
                <!-- Date Of Sailing -->
                <div class="form-group">
                    <label for="txtDateOfSailing">Date of Sailing</label>
                    <input name="DateOfSailing" [(ngModel)]="accurateDataFormDateOfSailing" #dateOfSailingDatepicker="bsDatepicker" bsDatepicker [minDate]='null' [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour }" id="dpDateOfSailing" class="form-control">
                </div>
                <div class="form-group">
                  <label for="ddlRateId">Rate</label>

                  <select [(ngModel)]="getAccurateDataFormObject.RateId" class="form-control" id="ddlRateId" name="Rate">
                      <option value="" selected>Choose</option>
                      <option *ngFor="let rate of rates" [value]="rate?.Id" >
                          {{rate?.NameEN}}
                      </option>
                  </select>
              </div>
                <!-- Port Of Origin -->
                <div class="form-group">
                    <label for="txtPortOfOrigin">Port Of Origin</label>
                    <input type="text" name="PortOfOrigin" [(ngModel)]="getAccurateDataFormObject.PortOfOrigin" id="txtPortOfOrigin" class="form-control" />
                </div>
                <!-- Port Of Destination -->
                <div class="form-group">
                    <label for="txtPortOfDestination">Port Of Destination</label>
                    <input type="text" name="PortOfDestination" [(ngModel)]="getAccurateDataFormObject.PortOfDestination" id="txtPortOfDestination" class="form-control" />
                </div>
                <!-- SCNT -->
                <div class="form-group">
                    <label for="txtSCNT">Net Tonnage (SCNT)</label>
                    <input type="text" name="SCNT" [(ngModel)]="getAccurateDataFormObject.SCNT" id="txtSCNT" maxlength="2" class="form-control" />
                </div>
                <!-- Vessel Type -->
                <div class="form-group">
                    <label for="ddlVesselTypeId">Type of Vessel</label>
                    <select [(ngModel)]="getAccurateDataFormObject.VesselTypeId" class="form-control" id="ddlVesselTypeId" name="VesselType">
                        <option value="" selected>Choose</option>
                        <option *ngFor="let vesselType of rebateRequest.vesselTypes" [value]="vesselType?.Id" >
                            {{vesselType?.NameEN}}
                        </option>
                    </select>
                </div>
                <!-- Kind of Cargo -->
                <div class="form-group">
                    <label for="txtCargo">Kind of Cargo</label>
                    <input type="text" [(ngModel)]="getAccurateDataFormObject.Cargo" name="Cargo" id="txtCargo" class="form-control" />
                </div>
                <!-- Other Charges -->
                <div class="form-group">
                    <label for="txtOtherCharges">Extra dues (Other charges)</label>
                    <input type="text" [(ngModel)]="getAccurateDataFormObject.OtherCharges" name="OtherCharges" id="txtOtherCharges" class="form-control" />
                </div>
                <!-- Deadweight -->
                <div class="form-group">
                    <label for="txtDeadweight">Deadweight</label>
                    <input type="text" [(ngModel)]="getAccurateDataFormObject.Deadweight" name="Deadweight" id="txtDeadweight" class="form-control" />
                </div>
                <!-- Number of Esc. Tugs -->
                <div class="form-group">
                    <label for="NoOfEscTugs">Number of Esc. Tugs</label>
                    <input type="number" min="0" class="form-control" id="txtNoOfEscTugs" name="NoOfEscTugs" [(ngModel)]="getAccurateDataFormObject.NoOfEscTugs" />
                </div>
                <!-- Number of Imposed Tugs -->
                <div class="form-group">
                    <label for="NoOfImposedTugs">Number of Imposed Tugs</label>
                    <input type="number" min="0" class="form-control" id="txtNoOfImposedTugs" name="NoOfImposedTugs" [(ngModel)]="getAccurateDataFormObject.NoOfImposedTugs" />
                </div>
                <!-- Remarks -->
                <div class="form-group">
                    <label for="txtRemarks">Remarks</label>
                    <textarea type="text" [(ngModel)]="getAccurateDataFormObject.Remarks" name="Remarks" id="txtRemarks" class="form-control"></textarea>
                </div>
            </div>
        </fieldset>
    </div>
    <div class="form-container">
        <!-- Long Haul Request Option(s) Section -->
        <div id="divLongHaulRequestOptions" class="form-section">
            <h4 class="section-title">Rebate Request Option(s)</h4>
            <div class="form-group">
                <label for="ddlOptions">Options</label>
                <select [(ngModel)]="currentSelctedOption"  class="form-control" id="ddlOptions" name="Options" (change)="onOptionChange($event)">
                    <option [value]="null" selected>Choose</option>
                    <option *ngFor="let releaseRebateOption of releaseRebateOptions; let i = index;" [value]="releaseRebateOption?.Id" [class.checkDone]="releaseRebateOption.IsOptionAdminDone" >
                        <span *ngIf="releaseRebateOption.IsOptionAdminDone">&#x2713;</span>
                        Option {{i + 1}} ({{releaseRebateOption.LastPortOfOrigin}} - {{releaseRebateOption.FirstPortOfDestination}})
                    </option>
                </select>
                <div *ngIf="isOptionsRebateArrNotValid" class="red">
                    <span>Please submit all Options Rebate Percentage Decision</span>
                </div>
            </div>
        </div>
        <!-- Long Haul Request Option Details -->
        <div *ngIf="isOptionDetailsSelected" class="form-container">
            <h4 class="section-title">
                {{optionSelectedText}} Rebate Percentage
            </h4>
        </div>
        <div *ngIf="isOptionDetailsSelected" class="read-only-content">
            <div class="form-section">
                <!-- Rebate Percentage (%) -->
                <div class="form-group">
                    <label for="lblRebatePercentage">Rebate Percentage (%)</label>
                    <div class="input-group">
                        <label name="RebatePercentage" id="lblRebatePercentage" class="form-control">{{selectedLongHaulRequestOption.RebatePercentageLetters}}</label>
                        <span class="input-group-addon">%</span>
                    </div>
                </div>
            </div>
        </div>
        <form name="form" #f="ngForm" style="width:100%;">
            <!-- Change Rebate Decision Section -->
            <div *ngIf="isOptionDetailsSelected" class="form-section">
                <h4 class="section-title">Change Rebate %</h4>
                <div class="form-group">
                    <label>Change Rebate % Decision</label>
                    <span *ngIf="formMode == 1" class="red"> *</span>
                    <div>
                        <div class="custom-Radio">
                            <input type="radio" [disabled]="formMode == 2" [(ngModel)]="selectedLongHaulRequestOption.DecisionIdString" id="rbtnLongHaulRequestOptionChangeRebateDecisionUpdate" name="LongHaulRequestOptionChangeRebateDecisionIdUpdate" value="5" (change)="onOptionChangeRebateDecisionChange()" required #optionRebatePercentageDecision="ngModel" />
                            <label for="rbtnLongHaulRequestOptionChangeRebateDecisionUpdate">Update %</label>
                        </div>
                    </div>
                    <div>
                        <div class="custom-Radio">
                            <input type="radio" [disabled]="formMode == 2" [(ngModel)]="selectedLongHaulRequestOption.DecisionIdString" id="rbtnLongHaulRequestOptionChangeRebateDecisionConfirm" name="LongHaulRequestOptionChangeRebateDecisionIdConfirm" value="6" (change)="onOptionChangeRebateDecisionChange()" required #optionRebatePercentageDecision="ngModel" />
                            <label for="rbtnLongHaulRequestOptionChangeRebateDecisionConfirm">Confirm Granted %</label>
                        </div>
                    </div>
                    <div>
                        <div class="custom-Radio">
                            <input type="radio" [disabled]="formMode == 2" [(ngModel)]="selectedLongHaulRequestOption.DecisionIdString" id="rbtnLongHaulRequestOptionChangeRebateDecisionCancel" name="LongHaulRequestOptionChangeRebateDecisionIdCancel" value="7" (change)="onOptionChangeRebateDecisionChange()" required #optionRebatePercentageDecision="ngModel" />
                            <label for="rbtnLongHaulRequestOptionChangeRebateDecisionCancel">Cancel Rebate %</label>
                        </div>
                    </div>
                    <div *ngIf="isOptionSubmitted && optionRebatePercentageDecision?.invalid" class="red">
                        <span *ngIf="optionRebatePercentageDecision?.errors?.required">This Field is Required</span>
                    </div>
                </div>
                <!-- Updated Rebate % -->
                <div *ngIf="selectedLongHaulRequestOption.DecisionIdString == '5'" class="form-group">
                    <label for="txtUpdatedRebatePercentage">Updated Rebate %</label>
                    <span *ngIf="formMode == 1" class="red"> *</span>
                    <div class="input-group">
                        <input type="text" [disabled]="formMode == 2" pattern="[0-9]{1,2}" minlength="1" #txtUpdatedRebatePercentage="ngModel" min="0" max="100" maxlength="2" [(ngModel)]="selectedLongHaulRequestOption.UpdatedRebatePercentage" name="UpdatedRebatePercentage" id="txtUpdatedRebatePercentage" class="form-control" (change)="rebatePercentageChange($event)" (keyup)="rebatePercentageChange($event)" (keydown)="rebatePercentageChange($event)" (blur)="rebatePercentageChange($event)" (paste)="rebatePercentageChange($event)" />
                        <span class="input-group-addon">%</span>
                    </div>
                    <div *ngIf="updatedRebatePercentageNotValid" class="red">
                        <span>This Field is Required</span>
                    </div>
                    <div *ngIf="txtUpdatedRebatePercentage?.invalid" class="red">
                        <span *ngIf="txtUpdatedRebatePercentage?.errors?.pattern">Please enter a Valid Rebate Percentage Number</span>
                    </div>
                    <div *ngIf="updatedRebatePercentageValueNotValid" class="red">
                        <span>Rebate Percentage Value not Updated</span>
                    </div>
                </div>
                <!-- Confirm Rebate % -->
                <div *ngIf="selectedLongHaulRequestOption.DecisionIdString == '6'" class="form-group">
                    <label>Option Rebate Percentage Status</label>
                    <div class="bs-callout bs-callout-success">
                        <p>
                            <span>&#x2713;</span> Rebate Percentage Confirmed
                        </p>
                    </div>
                </div>
                <!-- Cancel Rebate % -->
                <div *ngIf="selectedLongHaulRequestOption.DecisionIdString == '7'" class="form-group">
                    <label>Cancelation Reason</label>
                    <span *ngIf="formMode == 1" class="red"> *</span>
                    <textarea type="text" [disabled]="formMode == 2" [(ngModel)]="selectedLongHaulRequestOption.CancelationReason" name="CancelationReason" id="txtCancelationReason" class="form-control" (change)="onCancelationReasonChange()" (keyup)="onCancelationReasonChange()" (keydown)="onCancelationReasonChange()" (blur)="onCancelationReasonChange()" (paste)="onCancelationReasonChange()"></textarea>
                    <div *ngIf="cancelationReasonNotValid" class="red">
                        <span>This Field is Required</span>
                    </div>
                </div>
            </div>
            <!-- Add Option Rebate Percentage Decision -->
            <p *ngIf="isOptionDetailsSelected && formMode == 1" class="btns-holder">
                <button type="button" class="btn SCAcustomBtn" (click)="isOptionSubmitted = true; f.form.valid && addOptionRebatePercentageDecision()">Add Option Rebate Percentage Decision</button>
            </p>
        </form>
        <!-- Message -->
        <div *ngIf="isFormSubmitted || formMode == 2" class="form-section">
            <div class="form-group">
                <label>Message</label>
                <span *ngIf="formMode == 1" class="red"> *</span>
                <textarea type="text" [disabled]="formMode == 2" [(ngModel)]="longHaulRequestReleaseRebate.ReleaseRebateMessage" name="ReleaseRebateMessage" id="txtReleaseRebateMessage" class="form-control" (change)="onReleaseRebateMessageChange()" (keyup)="onReleaseRebateMessageChange()" (keydown)="onReleaseRebateMessageChange()" (blur)="onReleaseRebateMessageChange()" (paste)="onReleaseRebateMessageChange()"></textarea>
                <div *ngIf="releaseRebateMessageNotValid" class="red">
                    <span>This Field is Required</span>
                </div>
            </div>
        </div>
        <div *ngIf="isFormSubmitted" class="form-group">
            <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="submit()">Submit</button>
            <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
        </div>
    </div>
</div>
<!-- Confirmation -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>You have Marked this Rebate Request as Refunded</p>
        <p>Go Back to <a routerLink="/RebateRequest/RequestsManagement">Requests Management</a></p>
    </div>
</div>
<!-- Warning -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 2" class="alert alert-warning" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>This task was submitted before</p>
        <p>Go Back to <a routerLink="/RebateRequest/RequestsManagement">Requests Management</a></p>
    </div>
</div>
<!-- Error -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 3" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>Something went wrong, Please contact System Administrator</p>
        <hr>
        <p>Go Back to <a routerLink="/workspace">Workspace</a></p>
    </div>
</div>
